module.exports = function(bootstrap) {
    bootstrap.run(["Service", function (Service) {
     
        return new Service({

            name: 'vendorSSO',
            group: "eprsvc",
            url: "/eprsvc/x-services/secure/reports/v1/mede-analytics",
            headers: {},
            withCredentials:true,
            cache: false,

            getSSOParams: function(vendor) {
                this.url=this.url+vendor;
                return this.post(
                    {
                        baseMessage: null,
                        payload: null
                    }
                );
            },
            medeUpdate:function(loginId,bpdId,aso)
            {
           //this.url="https://lhdp-qata-eprcmn-main-a-empcmn.apps.ocbrlnxd01.ocp.highmark.com/services/v1/mede-analytics/updateUserRole";
           //this.url='/eprsvc/x-services/secure/reports/v1/mede-analytics';
           this.headers['x-hmhs-keyId'] = "966282fd-a8cd-4848-aebb-253ef87c4fb8";
          
           
           return this.post(
            {
                payload:{
                loginId: loginId,
                aso: aso,
                bpdId: bpdId
                }             
            })
            }

        });
    }]);
};
